import { createSlice, PayloadAction, createAction } from "@reduxjs/toolkit";

type initialState = {
  unAuthorized: boolean;
  nameErrorMessage: string;
  fieldErrorMessage: string;
  nameInEnglishMessage: string;
  brokerTypeMessage: string;
  emailErrorMessage: string;
  secondaryEmailErrorMessage: string;
  passwordErrorMessage: string;
  mobileErrorMessage: string;
  secondaryMobileErrorMessage: string;
  confirmPasswordErrorMessage: string;
  lastNameErrorMessage: string;
  preferredBHKErrorMessage: string;
  projectErrorMessage: string;
  leadMinBudgetErrorMessage: string;
  leadMaxBudgetErrorMessage: string;
  otpErrorMessage: string;
  residenceStatusMessage: string;
  companyTypeMessage: string;
  countryMessage: string;
  cityMessage: string;
  addressInEnglishMessage: string;
  telephoneMessage: string;
  mobileMessage: string;
  NationalityMessage: string;
  countryContactDetailMessage: string;
  addressContactDetailMessage: string;
  mobileContactDetailMessage: string;
  emailContactDetailMessage: string;
  passportIssuDateMessage: string;
  passportExpiryDate: string;
  primaryContactDetail: string;
  bankAccountSwiftCode: string;
};

const initialState: initialState = {
  unAuthorized: false,
  nameErrorMessage: "",
  emailErrorMessage: "",
  nameInEnglishMessage: "",
  secondaryEmailErrorMessage: "",
  passwordErrorMessage: "",
  mobileErrorMessage: "",
  fieldErrorMessage: "",
  secondaryMobileErrorMessage: "",
  confirmPasswordErrorMessage: "",
  lastNameErrorMessage: "",
  preferredBHKErrorMessage: "",
  projectErrorMessage: "",
  leadMinBudgetErrorMessage: "",
  leadMaxBudgetErrorMessage: "",
  otpErrorMessage: "",
  brokerTypeMessage: "",
  residenceStatusMessage: "",
  companyTypeMessage: "",
  countryMessage: "",
  cityMessage: "",
  addressInEnglishMessage: "",
  telephoneMessage: "",
  mobileMessage: "",
  NationalityMessage: "",
  countryContactDetailMessage: "",
  addressContactDetailMessage: "",
  mobileContactDetailMessage: "",
  emailContactDetailMessage: "",
  passportIssuDateMessage: "",
  passportExpiryDate: "",
  primaryContactDetail: "",
  bankAccountSwiftCode: "",
};

const ErrorSlice = createSlice({
  name: "errorMessage",
  initialState,
  reducers: {
    setUnAuthorized: (state: initialState, action: PayloadAction<boolean>) => {
      state.unAuthorized = action.payload;
    },
    setCountryContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.countryContactDetailMessage = action.payload;
    },

    setAddressContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.addressContactDetailMessage = action.payload;
    },
    setMobileContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.mobileContactDetailMessage = action.payload;
    },

    setEmailContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.emailContactDetailMessage = action.payload;
    },

    setPassportIssueDateContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.passportIssuDateMessage = action.payload;
    },

    setPassportExpiryDateContactDetailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.passportExpiryDate = action.payload;
    },

    setPrimaryContactDetailsErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.primaryContactDetail = action.payload;
    },

    setBankAccountSwiftCodeErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.bankAccountSwiftCode = action.payload;
    },
    setNameErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.nameErrorMessage = action.payload;
    },
    setFieldErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.fieldErrorMessage = action.payload;
    },
    setNameInEnglishErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.nameErrorMessage = action.payload;
    },
    setEmailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.emailErrorMessage = action.payload;
    },
    setSecondaryEmailErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.secondaryEmailErrorMessage = action.payload;
    },
    setPasswordErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.passwordErrorMessage = action.payload;
    },
    setMobileErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.mobileErrorMessage = action.payload;
    },
    setSecondaryMobileErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.secondaryMobileErrorMessage = action.payload;
    },
    setConfirmPasswordErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.confirmPasswordErrorMessage = action.payload;
    },
    setLastNameErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.lastNameErrorMessage = action.payload;
    },
    setPreferredBHKErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.preferredBHKErrorMessage = action.payload;
    },
    setProjectErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.projectErrorMessage = action.payload;
    },
    setLeadMinBudgetErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.leadMinBudgetErrorMessage = action.payload;
    },
    setLeadMaxBudgetErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.leadMaxBudgetErrorMessage = action.payload;
    },
    setOtpErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.otpErrorMessage = action.payload;
    },
    setBrokerTypeErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.brokerTypeMessage = action.payload;
    },
    setResidenceStatusErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.residenceStatusMessage = action.payload;
    },
    setCompanyTypeErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.companyTypeMessage = action.payload;
    },
    setCountryErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.countryMessage = action.payload;
    },
    setCityErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.cityMessage = action.payload;
    },
    setAddressInEnglishErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.addressInEnglishMessage = action.payload;
    },

    setTelephoneErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.telephoneMessage = action.payload;
    },
    setcompanyTypeErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.companyTypeMessage = action.payload;
    },
    setNationalityErrorMessage: (
      state: initialState,
      action: PayloadAction<string>
    ) => {
      state.NationalityMessage = action.payload;
    },
  },
});

export default ErrorSlice.reducer;

export const {
  setBrokerTypeErrorMessage,
  setBankAccountSwiftCodeErrorMessage,
  setPrimaryContactDetailsErrorMessage,
  setPassportExpiryDateContactDetailErrorMessage,
  setPassportIssueDateContactDetailErrorMessage,
  setEmailContactDetailErrorMessage,
  setMobileContactDetailErrorMessage,
  setAddressContactDetailErrorMessage,
  setCountryContactDetailErrorMessage,
  setNationalityErrorMessage,
  setTelephoneErrorMessage,
  setResidenceStatusErrorMessage,
  setCompanyTypeErrorMessage,
  setCountryErrorMessage,
  setCityErrorMessage,
  setAddressInEnglishErrorMessage,
  setUnAuthorized,
  setNameErrorMessage,
  setEmailErrorMessage,
  setSecondaryEmailErrorMessage,
  setPasswordErrorMessage,
  setMobileErrorMessage,
  setSecondaryMobileErrorMessage,
  setConfirmPasswordErrorMessage,
  setLastNameErrorMessage,
  setPreferredBHKErrorMessage,
  setProjectErrorMessage,
  setLeadMinBudgetErrorMessage,
  setLeadMaxBudgetErrorMessage,
  setOtpErrorMessage,
  setFieldErrorMessage,
  setNameInEnglishErrorMessage,
} = ErrorSlice.actions;
